import { filterStyles as styles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css`
        ${styles.container?.css}
        margin-block-end: 40px;
        padding-bottom: 0;
        ${mediaQueriesBP.maxMD} {
            margin-block-end: 24px;
        }
    `,
};

styles.heading = {
    ...styles.heading,
    variant: "h4",
};

styles.clearFiltersButton = {
    ...styles.clearFiltersButton,
    css: css`
        ${styles.clearFiltersButton?.css}
        margin-right: 0;
    `,
};

styles.shipToGridItem = {
    ...styles.shipToGridItem,
    width: [12, 12, 6, 6, 6],
};

styles.invoiceNumberGridItem = {
    ...styles.invoiceNumberGridItem,
    width: [12, 12, 3, 3, 2],
};

styles.orderNumberGridItem = {
    ...styles.orderNumberGridItem,
    width: [12, 12, 3, 3, 2],
};

styles.fromGridItem = {
    ...styles.fromGridItem,
    css: css`
        & > div {
            width: 100%;
        }
    `,
};

styles.toGridItem = {
    ...styles.toGridItem,
    css: css`
        & > div {
            width: 100%;
        }
    `,
};

styles.onlyOpenGridItem = {
    ...styles.onlyOpenGridItem,
    width: 12,
    align: "bottom",
    css: css`
        padding-top: 11px;
    `,
};

styles.onlyOpenCheckbox = {
    ...styles.onlyOpenCheckbox,
    typographyProps: {
        css: css`
            font-weight: 400;
        `,
    },
};

styles.clearFiltersButton = {
    ...styles.clearFiltersButton,
    variant: "primary",
};
